import { Link } from "react-router-dom";
import { heroBackground } from "@/mocks/manga";

export default function Hero() {
  return (
    <section className="relative flex min-h-[560px] w-full items-center justify-center overflow-hidden md:min-h-[640px]">
      <div className="absolute inset-0">
        <img
          src={heroBackground}
          alt="雪夜小镇 冬日漫画 首页背景"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/55 to-background-50"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/50 via-transparent to-background-950/50"></div>
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-4 pb-16 pt-28 text-center md:px-6">
        <span className="mb-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-accent-500/40 bg-accent-500/10 px-4 py-1.5 text-sm text-accent-500">
          <i className="ri-snowy-line"></i>
          冬日题材漫画在线阅读站
        </span>
        <h1 className="font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
          吹雪漫画网
          <span className="mx-3 text-primary-500">·</span>
          在雪落之前，读完一个冬天
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-7 text-foreground-300 md:text-lg md:leading-8">
          专注收录雪景、冬日、雪国、冰雪、冬物语与雪女传说等冷门佳作。
          高清在线看、分类清晰、点开即读、追更不迷路，让每一个喜欢冰雪故事的人都有处可去。
        </p>
        <div className="mt-9 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/category/xuejing"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-600"
          >
            <i className="ri-book-open-line"></i>
            浏览雪景漫画
          </Link>
          <Link
            to="/category/dongwuyu"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300/40 bg-background-950/40 px-7 py-3 text-sm font-semibold text-foreground-950 backdrop-blur-sm transition-colors hover:bg-background-950/70"
          >
            <i className="ri-sparkling-line"></i>
            看看冬物语
          </Link>
        </div>

        <dl className="mt-12 grid w-full max-w-2xl grid-cols-2 gap-4 sm:grid-cols-4">
          {[
            { num: "1200+", label: "收录作品" },
            { num: "6", label: "冬日题材" },
            { num: "98%", label: "高清原图" },
            { num: "24h", label: "每日更新" },
          ].map((s) => (
            <div key={s.label} className="rounded-lg border border-background-300/40 bg-background-950/35 px-3 py-4 text-center backdrop-blur-sm">
              <dd className="font-heading text-2xl font-bold text-primary-500">{s.num}</dd>
              <dt className="mt-1 text-xs text-foreground-400">{s.label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}